import { useMutation, useQueryClient } from "react-query";
import { message } from "antd";
import { API_URL } from "../../../../BaseUrlApi/Url";
import API from "@Config/axios";

export const useDeleteChildMutation = (parentId) => {
  const queryClient = useQueryClient();
  return useMutation(
    async (rowId) => {
      await API.delete(`${API_URL}/admin/children/${rowId}`);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["parentDetail", parentId]);
        message.success("Berhasil menghapus data anak.");
      },
      onError: () => {
        message.error("Gagal menghapus data anak.");
      },
    }
  );
};
